
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vender",
      function () {
        return require("private-next-pages/vender/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vender"])
      });
    }
  